/**
 * Created by vladislav on 30.12.2021
 */

cleverapps.Boosters.CONFIG = {};

cleverapps.Boosters.TYPES = {
    CHEAP: "cheap",
    MEDIUM: "medium",
    EXPENSIVE: "expensive",
    BEFORE_CHEAP: "before_cheap",
    BEFORE_MEDIUM: "before_medium",
    BEFORE_EXPENSIVE: "before_expensive"
};

cleverapps.Boosters.CONFIG[cleverapps.Boosters.TYPE_HINT] = {
    model: HintBooster,
    type: cleverapps.config.name === "scramble" ? cleverapps.Boosters.TYPES.EXPENSIVE : cleverapps.Boosters.TYPES.CHEAP,
    force: Forces.FREE_HINT_FORCE,
    limit: AdsLimits.TYPES.BOOSTER_1,
    available: cleverapps.config.availables.HINT_BOOSTER
};

cleverapps.Boosters.CONFIG[cleverapps.Boosters.TYPE_OPEN_LETTER] = {
    model: OpenLetterBooster,
    type: cleverapps.Boosters.TYPES.EXPENSIVE,
    force: Forces.FREE_OPEN_LETTER_FORCE,
    limit: AdsLimits.TYPES.BOOSTER_3,
    available: cleverapps.config.availables.OPEN_LETTER_BOOSTER
};

cleverapps.Boosters.CONFIG[cleverapps.Boosters.TYPE_WILDCARD] = {
    model: WildcardBooster,
    type: cleverapps.Boosters.TYPES.EXPENSIVE,
    limit: AdsLimits.TYPES.BOOSTER_3,
    available: cleverapps.config.availables.WILDCARD_BOOSTER
};

cleverapps.Boosters.CONFIG[cleverapps.Boosters.TYPE_SHUFFLE] = {
    model: ShuffleBooster,
    force: Forces.FREE_SHUFFLE_FORCE,
    type: cleverapps.Boosters.TYPES.CHEAP,
    limit: AdsLimits.TYPES.BOOSTER_2,
    available: cleverapps.config.availables.SHUFFLE_BOOSTER
};

cleverapps.Boosters.CONFIG[cleverapps.Boosters.TYPE_BRUSH] = {
    model: BrushBooster,
    force: Forces.FREE_PAINT_FORCE,
    type: cleverapps.Boosters.TYPES.EXPENSIVE,
    limit: AdsLimits.TYPES.BOOSTER_3,
    available: cleverapps.config.availables.BRUSH_BOOSTER
};

cleverapps.Boosters.CONFIG[cleverapps.Boosters.TYPE_DISCOVER] = {
    model: DiscoverBooster,
    force: Forces.FREE_HINT_FORCE,
    limit: AdsLimits.TYPES.BOOSTER_1,
    type: cleverapps.Boosters.TYPES.CHEAP,
    available: cleverapps.config.availables.DISCOVER_BOOSTER
};

cleverapps.Boosters.CONFIG[cleverapps.Boosters.TYPE_TILE_SHUFFLE] = {
    model: TileShuffleBooster,
    force: Forces.FREE_SHUFFLE_FORCE,
    type: cleverapps.Boosters.TYPES.CHEAP,
    executeEffect: "booster.tile_shuffle.execute",
    limit: AdsLimits.TYPES.BOOSTER_2,
    available: cleverapps.config.availables.TILE_SHUFFLE_BOOSTER
};

cleverapps.Boosters.CONFIG[cleverapps.Boosters.TYPE_UNDO] = {
    model: UndoBooster,
    force: Forces.FREE_UNDO_FORCE,
    type: cleverapps.config.type === "tile3" ? cleverapps.Boosters.TYPES.MEDIUM : cleverapps.Boosters.TYPES.CHEAP,
    executeEffect: "booster.undo.execute",
    limit: AdsLimits.TYPES.BOOSTER_1,
    available: cleverapps.config.availables.UNDO_BOOSTER
};

cleverapps.Boosters.CONFIG[cleverapps.Boosters.TYPE_VACUUM] = {
    model: VacuumBooster,
    force: Forces.FREE_VACUUM_FORCE,
    type: cleverapps.Boosters.TYPES.EXPENSIVE,
    executeEffect: "booster.vacuum.execute",
    limit: AdsLimits.TYPES.BOOSTER_3,
    available: cleverapps.config.availables.VACUUM_BOOSTER
};

cleverapps.Boosters.CONFIG[cleverapps.Boosters.TYPE_REPLACE_ALL] = {
    model: ReplaceAllBooster,
    force: Forces.FREE_REPLACE_ALL_FORCE,
    type: cleverapps.Boosters.TYPES.MEDIUM,
    executeEffect: "booster.replace.execute",
    limit: AdsLimits.TYPES.BOOSTER_2,
    available: cleverapps.config.availables.REPLACE_ALL_BOOSTER
};

cleverapps.Boosters.CONFIG[cleverapps.Boosters.TYPE_CLEAR_PIECES] = {
    model: ClearPiecesBooster,
    force: Forces.FREE_NEXT_PIECES_FORCE,
    type: cleverapps.Boosters.TYPES.EXPENSIVE,
    limit: AdsLimits.TYPES.BOOSTER_2,
    available: cleverapps.config.availables.CLEAR_PIECES_BOOSTER
};

cleverapps.Boosters.CONFIG[cleverapps.Boosters.TYPE_UNDO_PIECE] = {
    model: UndoPieceBooster,
    force: Forces.FREE_UNDO_PIECE,
    type: cleverapps.Boosters.TYPES.CHEAP,
    executeEffect: "booster.undo_piece.execute",
    limit: AdsLimits.TYPES.BOOSTER_1,
    available: cleverapps.config.availables.UNDO_PIECE_BOOSTER
};
